module.exports = __webpack_public_path__ + "img/img_liangbu@2x.9ee34245.png";